import React from "react";
import ModelViewer from "./3DModel"; // Corrected import path
import Button from "../Button";

interface CTASectionProps {
  modelUrl: string;
  title: string;
  description: string;
}

const CTASection: React.FC<CTASectionProps> = ({
  modelUrl,
  title,
  description,
}) => {
  return (
    <section className="bg-[#10031dff] py-16 text-white text-center">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-center space-y-8 md:space-y-0 md:space-x-8">
        <div className="w-full h-64 md:w-1/2 cursor-grab flex flex-col items-center justify-center">
          <ModelViewer modelUrl={modelUrl} scale={0.5} />
          <img src="/icons/360icon.png" alt="360deg-icon" className="w-10 h-10"/>
        </div>
        <div className="md:w-1/2">
          <h2 className="text-3xl font-bold mb-4 font-starforge">{title}</h2>
          <p className="text-xl mb-8 font-orbitron">{description}</p>
          <Button href={"/contact"}>Contact Us</Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
